'use client';

import React from 'react';
// import { ReactNode } from 'react';
// import { CardProps } from '@/app/shared/ui/Card';
import { LazyLoadWrapper } from '@/app/shared/common/LazyLoadWrapper';
import Card from '@/app/shared/ui/Card';
import {
  Modular,
  Dollar,
  LifeRing,
  Cog,
  CMS,
  Speedometer,
} from '@/app/shared/ui/icons';

const cards = [
  {
    id: 1,
    title: 'Modular Design',
    description:
      'Our innovative system is designed to be modular, allowing for easy customization to fit your specific needs.',
    icon: Modular,
  },
  {
    id: 2,
    title: 'Affordable Excellence',
    description:
      'We offer this cutting-edge display at an unbeatable price, ensuring you get the best value for your investment.',
    icon: Dollar,
  },
  {
    id: 3,
    title: 'Rapid Deployment',
    description:
      'With our efficient processes, we can deliver your display solution on short lead times, so you can start impressing your audience sooner.',
    icon: Speedometer,
  },
  {
    id: 4,
    title: 'Comprehensive Support',
    description:
      'We provide full support, including installation and content management, to ensure a seamless and hassle-free experience.',
    icon: LifeRing,
  },
  {
    id: 5,
    title: 'State-of-the-Art CMS',
    description:
      'Our state-of-the-art CMS can be used to manage content dynamically on displays in real time, ensuring that digital signage and interactive displays always deliver the most current, engaging content.',
    icon: CMS,
  },
  {
    id: 6,
    title: 'Self-Managed Option',
    description:
      'Alternatively, we offer a flexible option where you can install and manage the display yourself, giving you full control and autonomy.',
    icon: Cog,
  },
];

export default function BenefitsSection() {
  return (
    <div className='w-full perspective-2500'>
      <div className='container mx-auto px-4 py-12 phone:px-4'>
        <div className='max-w-[1600px] mx-auto'>
          <div className='grid mobile:grid-cols-1 tablet:grid-cols-1 desktop:grid-cols-2 desktopxl:grid-cols-2 desktopxxl:grid-cols-3 gap-8 place-items-center'>
            {cards.map((card) => (
              <LazyLoadWrapper key={card.id} className='w-full'>
                <Card
                  id={card.id}
                  title={card.title}
                  description={card.description}
                  icon={card.icon}
                  className='min-h-[450px] opacity-0 animate-fadeIn'
                />
              </LazyLoadWrapper>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
